import React, { useState, useEffect } from "react";
import apiClient from "../../AppClient";
import { Container, Table, Alert, Spinner, Card } from "react-bootstrap";

const MostFrequentCustomersReport = () => {
  const [customersData, setCustomersData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch most frequent customers data
  const fetchCustomersData = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get("/transactions/reports/most-frequent-customers");
      setCustomersData(response.data);
      setError(null);
    } catch (error) {
      setError(error.response?.data?.detail || "فشل في جلب تقرير العملاء الأكثر تكرارًا.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomersData();
  }, []);

  return (
    <Container style={{ 
      direction: "rtl", 
      textAlign: "right", 
      padding: "20px", 
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      color: "black", 
      backgroundColor: "white" 
    }}>
      <h1 style={{ color: "darkgreen", marginBottom: "20px" }}>تقرير العملاء الأكثر تكرارًا</h1>

      {/* Error Message */}
      {error && <Alert variant="danger">{error}</Alert>}

      {/* Loading Spinner */}
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" role="status" style={{ color: "darkgreen" }}>
            <span className="visually-hidden">جاري التحميل...</span>
          </Spinner>
        </div>
      ) : (
        /* Most Frequent Customers Table */
        <Card style={{ padding: "20px", border: "1px solid darkgreen", borderRadius: "5px" }}>
          <h4 style={{ color: "darkgreen" }}>العملاء الأكثر تكرارًا</h4>
          <Table hover responsive>
            <thead style={{ backgroundColor: "darkgreen", color: "white" }}>
              <tr>
                <th>اسم العميل</th>
                <th>تاريخ آخر عملية شراء</th>
                <th>إجمالي قيمة المشتريات</th>
                <th>عدد المشتريات</th>
              </tr>
            </thead>
            <tbody>
              {customersData?.map((customer, index) => (
                <tr key={index}>
                  <td>{customer.customer_name}</td>
                  <td>{customer.last_purchase_date || "لا يوجد"}</td>
                  <td>{customer.total_purchase_value ? customer.total_purchase_value.toFixed(2) : "لا يوجد"}</td>
                  <td>{customer.purchase_count}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card>
      )}
    </Container>
  );
};

export default MostFrequentCustomersReport;
